import { render, staticRenderFns } from "./crmNav.vue?vue&type=template&id=552f2050&"
import script from "./crmNav.vue?vue&type=script&lang=js&"
export * from "./crmNav.vue?vue&type=script&lang=js&"
import style0 from "./crmNav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports